import React from "react";
import {
  ConnectionIcon,
  LogsIcon,
  PrivacyIcon,
  SmartLocationIcon,
  SplitTunnelingIcon,
  VpnSpeedIcon,
} from "../../../assets/icons";
import FeatureDescription from "./FeatureDescription";

export default function FeatureDescriptionList() {
  const features = [
    {
      title: (
        <h2 className="mb-[12px] mt-4 text-left font-manrope text-[16px] font-[800] leading-[22px] text-[#333333] md:text-[18px] md:font-[800] md:leading-[24px] 2xl:mb-[20px] 2xl:mt-[32px] 2xl:text-[22px] 2xl:leading-[30px]">
          No-Logs <br /> Policy
        </h2>
      ),
      description: (
        <p className="text-wrap text-left font-manrope text-[12px] font-semibold leading-[16px] text-[#666A7C] md:text-[13px] md:font-[600] md:leading-[18px] 2xl:text-nowrap 2xl:text-[15px] 2xl:leading-[22px]">
          We never track, store, or share <br className="break-container" />{" "}
          your browsing data—your <br className="break-container" />
          online activity stays <br className="break-container" /> completely
          private.
        </p>
      ),
      Icon: <LogsIcon />,
    },
    {
      title: (
        <h2 className="mb-[12px] mt-4 text-left font-manrope text-[16px] font-[800] leading-[22px] text-[#333333] md:text-[18px] md:font-[800] md:leading-[24px] 2xl:mb-[20px] 2xl:mt-[32px] 2xl:text-[22px] 2xl:leading-[30px]">
          Enhanced Privacy Protection
        </h2>
      ),
      description: (
        <p className="text-wrap text-left font-manrope text-[12px] font-semibold leading-[16px] text-[#666A7C] md:text-[13px] md:font-[600] md:leading-[18px] 2xl:text-nowrap 2xl:text-[15px] 2xl:leading-[22px]">
          Shield your online activity <br className="break-container" /> from
          trackers, ads, and data <br className="break-container" />
          collectors for complete <br className="break-container" /> anonymity
          and peace of mind.
        </p>
      ),
      Icon: <PrivacyIcon />,
    },
    {
      title: (
        <h2 className="mb-[12px] mt-4 text-left font-manrope text-[16px] font-[800] leading-[22px] text-[#333333] md:text-[18px] md:font-[800] md:leading-[24px] 2xl:mb-[20px] 2xl:mt-[32px] 2xl:text-[22px] 2xl:leading-[30px]">
          Smart Location Suggestions
        </h2>
      ),
      description: (
        <p className="text-wrap text-left font-manrope text-[12px] font-semibold leading-[16px] text-[#666A7C] md:text-[13px] md:font-[600] md:leading-[18px] 2xl:text-nowrap 2xl:text-[15px] 2xl:leading-[22px]">
          Get automatically connected <br className="break-container" /> to the
          optimal server for the <br className="break-container" /> best
          performance, speed, and <br className="break-container" /> security.
        </p>
      ),
      Icon: <SmartLocationIcon />,
    },
    {
      title: (
        <h2 className="mb-[12px] mt-4 text-left font-manrope text-[16px] font-[800] leading-[22px] text-[#333333] md:text-[18px] md:font-[800] md:leading-[24px] 2xl:mb-[20px] 2xl:mt-[32px] 2xl:text-[22px] 2xl:leading-[30px]">
          Faster VPN Server Speeds
        </h2>
      ),
      description: (
        <p className="text-wrap text-left font-manrope text-[12px] font-semibold leading-[16px] text-[#666A7C] md:text-[13px] md:font-[600] md:leading-[18px] 2xl:text-nowrap 2xl:text-[15px] 2xl:leading-[22px]">
          Instantly connect to the <br className="break-container" /> fastest
          server with just a tap <br className="break-container" /> and enjoy
          seamless, secure <br className="break-container" /> browsing with Geo
          VPN.
        </p>
      ),
      Icon: <VpnSpeedIcon />,
    },
    {
      title: (
        <h2 className="mb-[12px] mt-4 text-left font-manrope text-[16px] font-[800] leading-[22px] text-[#333333] md:text-[18px] md:font-[800] md:leading-[24px] 2xl:mb-[20px] 2xl:mt-[32px] 2xl:text-[22px] 2xl:leading-[30px]">
          Split <br className="break-container" /> Tunneling
        </h2>
      ),
      description: (
        <p className="text-wrap text-left font-manrope text-[12px] font-semibold leading-[16px] text-[#666A7C] md:text-[13px] md:font-[600] md:leading-[18px] 2xl:text-nowrap 2xl:text-[15px] 2xl:leading-[22px]">
          Decide which apps use the <br className="break-container" /> VPN and
          which connect <br className="break-container" /> directly, optimizing
          your <br className="break-container" /> internet experience.
        </p>
      ),
      Icon: <SplitTunnelingIcon />,
    },
    {
      title: (
        <h2 className="mb-[12px] mt-4 text-left font-manrope text-[16px] font-[800] leading-[22px] text-[#333333] md:text-[18px] md:font-[800] md:leading-[24px] 2xl:mb-[20px] 2xl:mt-[32px] 2xl:text-[22px] 2xl:leading-[30px]">
          Instant Connection <br className="break-container" /> Alerts
        </h2>
      ),
      description: (
        <p className="text-wrap text-left font-manrope text-[12px] font-semibold leading-[16px] text-[#666A7C] md:text-[13px] md:font-[600] md:leading-[18px] 2xl:text-nowrap 2xl:text-[15px] 2xl:leading-[22px]">
          Stay informed and updated <br className="break-container" /> with
          real-time notifications <br className="break-container" /> whenever
          your VPN is <br className="break-container" /> activated or
          disconnected.
        </p>
      ),
      Icon: <ConnectionIcon />,
    },
  ];

  return (
    <section className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5 2xl:gap-6">
      {features.map((feature, index) => (
        <div key={index}>
          <FeatureDescription
            Icon={feature.Icon}
            title={feature.title}
            description={feature.description}
            index={index}
          />
        </div>
      ))}
    </section>
  );
}
